import { history } from 'helpers/history'
import URI from 'urijs'
import superagent from 'superagent'
import { initCollaborativeIndexations } from '../collaborativeIndexations/actions'
import { buildFrontSearchParamsQueryString } from '../queryParams/selectors'
import { getNavigation } from '../navigation/selectors'
import { initMediaInfo } from '../mediaInfo/actions'
import { initAvailableFilters } from '../availableFilters/actions'
import {
    getCurrentMedia,
    getCurrentMediaRecordUrl,
} from './selectors'
import { getCurrentMediaOriginalLocation } from '../mediaList/selectors'
import { download } from '../../helpers/media'

export function refreshCurrentMediaUrl()
{
    return function refreshCurrentMediaUrl(dispatch, getState)
    {
        const media = getCurrentMedia(getState())
        dispatch(updateCurrentMediaUrl(media, true))
    }
}

export function updateCurrentMediaUrl(media, pushToHistory = true) {
    return function updateCurrentMediaUrl(dispatch, getState) {

        const queryParams = buildFrontSearchParamsQueryString(getState())
        var uri = new URI(`${media.url}`);

        const pathname = `${uri.pathname()}${queryParams}`

        const state = {
            currentMedia: media,
            navigation: getNavigation(getState()),
        }

        if(pushToHistory === true)
        {
            if(window.location.pathname === pathname)
            {
                return history.replace(pathname, state)
            }

            return history.push(pathname, state)
        }
    }
}

export function linkToCurrentMediaRecord() {
    return function linkToCurrentMediaRecord(dispatch, getState) {
        window.open(getCurrentMediaRecordUrl(getState()), '_blank')
    }
}

export const downloadOriginalMedia = () => (dispatch, getState) => {
    download(getCurrentMedia(getState()))
}

export const INIT_CURRENT_MEDIA = 'INIT_CURRENT_MEDIA'
export function initCurrentMedia(media, pushToHistory = true) {
    return function initCurrentMedia(dispatch, getState){

        if(media === undefined) return

        dispatch({
            type: INIT_CURRENT_MEDIA,
            media
        })

        dispatch(initMediaInfo(media))
        dispatch(initCollaborativeIndexations(media))
        dispatch(initAvailableFilters(media.type))
        dispatch(updateCurrentMediaUrl(media, pushToHistory))
    }
}

export const CURRENT_MEDIA_SOURCE_LOADING = 'CURRENT_MEDIA_SOURCE_LOADING'
export const currentMediaSourceLoading = (viewId) => ({ type: CURRENT_MEDIA_SOURCE_LOADING, viewId })

export const CURRENT_MEDIA_SOURCE_LOADED = 'CURRENT_MEDIA_SOURCE_LOADED'
export const currentMediaSourceLoaded = (viewId) => ({ type: CURRENT_MEDIA_SOURCE_LOADED, viewId })

export const CURRENT_MEDIA_SOURCE_UNLOADED = 'CURRENT_MEDIA_SOURCE_UNLOADED'
export const currentMediaSourceUnloaded = (viewId) => ({ type: CURRENT_MEDIA_SOURCE_UNLOADED, viewId })

export function unableToLoadCurrentMedia() {
    return async function unableToLoadCurrentMedia(dispatch, getState) {
        await superagent.get(getCurrentMediaOriginalLocation(getState()))
        .then(() => {
            dispatch(currentMediaUnsupported())
        })
        .catch(function() {
            dispatch(currentMediaUnavailable())
        })
    }
}

export const CURRENT_MEDIA_UNAVAILABLE = 'CURRENT_MEDIA_UNAVAILABLE'
export const currentMediaUnavailable = () => ({ type: CURRENT_MEDIA_UNAVAILABLE })

export const CURRENT_MEDIA_UNSUPPORTED = 'CURRENT_MEDIA_UNSUPPORTED'
export const currentMediaUnsupported = () => ({ type: CURRENT_MEDIA_UNSUPPORTED })
